/** Tiny external store for live call stats — keeps TopBar/stage off the quality update path. */

const listeners = new Set();

let snapshot = {
  uplink: 0,
  downlink: 0,
  level: 'good', // good | fair | poor
  bitrate: null,
  packetLoss: null,
  rtt: null,
  resolution: null,
};

export const getCallStats = () => snapshot;

export const subscribeCallStats = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setCallStats = (partial) => {
  const next = { ...snapshot, ...partial };
  const uplink = Number(next.uplink) || 0;
  const downlink = Number(next.downlink) || 0;
  const worst = Math.max(uplink, downlink);
  let level = 'good';
  if (worst >= 5) level = 'poor';
  else if (worst >= 3) level = 'fair';
  next.level = level;
  snapshot = next;
  listeners.forEach((l) => {
    try {
      l();
    } catch (_) {}
  });
};

export const resetCallStats = () => {
  snapshot = {
    uplink: 0,
    downlink: 0,
    level: 'good',
    bitrate: null,
    packetLoss: null,
    rtt: null,
    resolution: null,
  };
  listeners.forEach((l) => {
    try {
      l();
    } catch (_) {}
  });
};
